import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import BuildIcon from '@mui/icons-material/Build';

import Panel from '../ui/Panel';
import CodeBlock from './CodeBlock';

/** Collapsible JSON result block, rendered only when the payload exists. */
const ResultAccordion = ({ title, data }) =>
  data ? (
    <Accordion sx={{ mt: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle2">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CodeBlock fontSize="0.75rem">{JSON.stringify(data, null, 2)}</CodeBlock>
      </AccordionDetails>
    </Accordion>
  ) : null;

/** Ticket data health checks and the categorization repair action. */
const DiagnosticsSection = ({
  onRunDiagnostics,
  onFixCategories,
  diagnosticsLoading,
  fixCategoriesLoading,
  diagnosticsResults,
  fixResults,
}) => (
  <Panel
    title="Database Diagnostics"
    subtitle="Run diagnostics and fix data inconsistencies in the database."
  >
    <Alert severity="info" sx={{ mb: 2 }}>
      <AlertTitle>Fixing categorization issues</AlertTitle>
      If tickets show as “Uncategorized” in the UI, use these tools to diagnose and repair them. The
      fix operation applies proper categories and labels to all tickets in the database.
    </Alert>

    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
      <Button
        variant="outlined"
        disabled={diagnosticsLoading}
        startIcon={diagnosticsLoading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />}
        onClick={onRunDiagnostics}
      >
        {diagnosticsLoading ? 'Running…' : 'Run Diagnostics'}
      </Button>
      <Button
        variant="contained"
        disabled={fixCategoriesLoading}
        startIcon={fixCategoriesLoading ? <CircularProgress size={18} color="inherit" /> : <BuildIcon />}
        onClick={onFixCategories}
      >
        {fixCategoriesLoading ? 'Fixing…' : 'Fix Categories'}
      </Button>
    </Stack>

    <ResultAccordion title="Diagnostics Results" data={diagnosticsResults} />
    <ResultAccordion title="Fix Results" data={fixResults} />
  </Panel>
);

export default DiagnosticsSection;
